export type LoginProfile = "user" | "admin";
export const REMEMBERED_LOGIN_KEY = "carioprint_remembered_login_v1";

export function parseRememberedLogin(raw: string | null): { role: LoginProfile; email: string } {
  try {
    const value = JSON.parse(raw || "{}");
    return {
      role: value?.role === "admin" || value?.role === "developer" ? "admin" : "user",
      email: typeof value?.email === "string" ? value.email : "",
    };
  } catch { return { role: "user", email: "" }; }
}
